import { Modal, IconButton } from "@mui/material";

import { useEffect, useState } from "react";
import CloseIcon from "@mui/icons-material/Close";
import moment from "moment/moment";

// Custom Components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import LXOGeneralTaskForm from "components/LXOGeneralTaskForm/LXOGeneralTaskForm";

// Constants
import {
  GeneralTaskStatus,
  GeneralTaskFrequency,
  DAYS_OF_WEEK,
  DAYS_OF_MONTH,
  STATUS_LIST,
} from "constant/GeneralTaskType";

const VALID_DAYS_OF_WEEK = DAYS_OF_WEEK.map((day) => day.value);
const VALID_DAYS_OF_MONTH = DAYS_OF_MONTH.map((day) => day.value);

const ModalAdminActionTask = ({
  isOpen,
  onSubmit = () => {},
  onClose = () => {},
  action = "create",
  category = [],
  frequency = [],
  item = {},
}) => {
  const [state, setState] = useState({
    title: "",
    code: "",
    category: null,
    frequency: null,
    fromDate: moment().startOf("day"), // 04/06/2025 00:00:00
    toDate: moment().endOf("day"), // 04/06/2025 23:59:59
    recurrenceDay: null, // String: e.g., "Monday" for weekly, "4" for monthly
    startTime: moment(), // 13:51 (01:00 PM)
    endTime: moment().endOf("day"), // 23:59
    status: null,
    note: "",
    action,
  });
  const [error, setError] = useState({});

  const validate = () => {
    const errors = {};
    if (!state.title) {
      errors.title = "Title is required";
    }
    if (!state.code) {
      errors.code = "Code is required";
    }
    if (!state.category) {
      errors.category = "Category is required";
    }
    if (!state.frequency) {
      errors.frequency = "Frequency is required";
    }
    if (!state.fromDate || !state.fromDate.isValid()) {
      errors.fromDate = "Start date is required";
    }
    if (!state.toDate || !state.toDate) {
      errors.toDate = "End date is required";
    }
    if (!state.startTime || !state.startTime?.isValid()) {
      errors.startTime = "Start time is required";
    }
    if (!state.endTime || !state.endTime?.isValid()) {
      errors.endTime = "End time is required";
    }
    // Recurrence Day Validation
    if (!state.recurrenceDay) {
      errors.recurrenceDay = "Recurrence day is required";
    } else {
      if (state.frequency?.value === GeneralTaskFrequency.WEEKLY) {
        if (!VALID_DAYS_OF_WEEK.includes(state.recurrenceDay?.value)) {
          errors.recurrenceDay = "Invalid day of week";
        }
      } else if (state.frequency?.value === GeneralTaskFrequency.MONTHLY) {
        if (!VALID_DAYS_OF_MONTH.includes(state.recurrenceDay?.value)) {
          errors.recurrenceDay = "Invalid day of month";
        }
      }
    }

    if (
      state.fromDate &&
      state.toDate &&
      state.fromDate.isValid() &&
      state.toDate.isValid() &&
      state.fromDate.isAfter(state.toDate)
    ) {
      errors.fromDate = "Start date must be before end date";
    }

    if (
      state.startTime &&
      state.endTime &&
      state.startTime.isValid() &&
      state.endTime.isValid() &&
      state.startTime.isAfter(state.endTime)
    ) {
      errors.startTime = "Start time must be before end time";
    }

    setError(errors);
    return Object.keys(errors).length === 0;
  };

  useEffect(() => {
    if (action === "update" && item) {
      let recurrenceDay = null;
      if (item.recurrenceDay) {
        if (item.frequency === GeneralTaskFrequency.WEEKLY) {
          recurrenceDay = DAYS_OF_WEEK.find(
            (w) => w.value === item.recurrenceDay
          );
        } else if (item.frequency === GeneralTaskFrequency.MONTHLY) {
          recurrenceDay = DAYS_OF_MONTH.find(
            (m) => m.value === item.recurrenceDay
          );
        }
      }

      setState({
        id: item.id,
        title: item.title || "",
        code: item.code || "",
        category: category.find((c) => c.value === item.category) || null,
        frequency: frequency.find((f) => f.value === item.frequency) || null,
        fromDate: moment.utc(item.fromDate).local(),
        toDate: moment.utc(item.toDate).local(),
        startTime: moment.utc(item.startTime).local(),
        endTime: moment.utc(item.endTime).local(),
        status: item.status || GeneralTaskStatus.PENDING,
        note: item.note || "",
        recurrenceDay,
        action,
      });
    }
  }, [action, item]);

  const renderTitle = (action) => {
    switch (action) {
      case "create":
        return "Create task";
      case "update":
        return "Update task";
      case "delete":
        return "Delete task";
      default:
        return "Create new task";
    }
  };

  const propsLXOGeneralTaskForm = {
    action,
    item,
    onSubmit,
    onClose,
    state,
    setState,
    error,
    validate,
    category,
    frequency,
    statusList: STATUS_LIST,
  };

  return (
    <Modal open={isOpen} onClose={onClose}>
      <div className="modal-leave-application-container">
        <div className="modal-leave-application-container-wrapper">
          <MDBox className="modal-leave-application-header">
            <MDBox>
              <MDTypography
                className="modal-leave-application-title"
                variant="h5"
              >
                {renderTitle(action)}
              </MDTypography>
            </MDBox>
            <IconButton onClick={onClose} size="small">
              <CloseIcon />
            </IconButton>
          </MDBox>
          <LXOGeneralTaskForm {...propsLXOGeneralTaskForm} />
        </div>
      </div>
    </Modal>
  );
};

export default ModalAdminActionTask;
